import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn } from "../../../components/DataTable/DataTable.js";

import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P201List({ dataTable }) {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    globalFilter={globalFilter}
                    emptyMessage="ยังไม่ได้เพิ่มรายการ"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="caseType" header="ลักษณะงาน" body={(e) => normalColumn(e, "caseType", "ลักษณะงาน")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="casePipeSize" header="ขนาด" body={(e) => normalColumn(e, "casePipeSize", "ขนาด")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="caseQuantity" header="ปริมาณ" body={(e) => normalColumn(e, "caseQuantity", "ปริมาณ")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="caseUnit" header="หน่วย" body={(e) => normalColumn(e, "caseUnit", "หน่วย")} style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                </DataTable>
            </div>
        </div>
    );
}
